import React, { useEffect } from 'react';
import qs from 'qs';
import AppExpiredView from './AppExpiredView';
import useFmcHost from 'hooks/useFmcHost';
import { applicationTimeout } from 'fmc-sdk';
import useWorkflow from 'hooks/useWorkflow';
import { useSecureQueryParameters } from 'hooks/useQueryParameters';

const AppExpired: React.FC = props => {
  const fmcDispatch = useFmcHost();
  const allowedQueryParameters = useSecureQueryParameters();
  const { timeoutRestartPath } = useWorkflow();

  const restartLinkPath = `${process.env.REACT_BASENAME ||
    ''}${timeoutRestartPath}/${qs.stringify(allowedQueryParameters, {
    addQueryPrefix: true,
  })}`.replace(/\/\//g, '/');

  useEffect(() => {
    fmcDispatch(applicationTimeout());
  }, [fmcDispatch]);
  return <AppExpiredView {...props} restartPath={restartLinkPath} />;
};

export default AppExpired;
